import { buildAlignedTotalsRow, getColumnIndex } from '@components/shared/Table/helpers/buildAlignedTotalsRow'
import { numberMask } from '@utils/masks/cpfMask'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { WeeklyClBreakdownResponseProps } from '../context/types'

interface ParseWeeklyBreakdownTotalsProps {
  columns: ColumnDefProps[]
  data: WeeklyClBreakdownResponseProps | null
}

/**
 * Linha de totais do Detalhamento Semanal (visão geral): Total Quantidades sob "Qtd. Total",
 * Total Bruto sob "Total Bruto (R$)" e Total Líquido sob "Total Líquido (R$)".
 */
export const parseWeeklyBreakdownTotalsGrid = ({
  columns,
  data
}: ParseWeeklyBreakdownTotalsProps): ColumnDefProps[][] => {
  if (!columns.length || !data) return []

  const totalsRow = buildAlignedTotalsRow({
    columns,
    label: `Total Registros: ${numberMask(String(data.totalItems || 0))}`,
    labelSpan: getColumnIndex(columns, 'previousBilledQuantity'),
    values: {
      previousBilledQuantity: {
        label: 'Total Quantidades',
        value: numberMask(String(data.previousBilledQuantityTotal || 0))
      },
      totalGrossAmount: { label: 'Total Bruto', value: data.grossTotalAmount || 0, currency: true },
      totalNetAmount: { label: 'Total Líquido', value: data.netTotalAmount || 0, currency: true }
    }
  })

  return totalsRow.length ? [totalsRow] : []
}
